import { type ComponentPropsWithoutRef, type ElementType, type ReactElement } from 'react'

import { getNavigationAndActionIcon } from '@DS/components/icons/navigationAndActionIcons'

import LinkBase from '../_internal/LinkBase'
import { type LinkBaseProps } from '../_internal/LinkBase.types'

const ExternalLinkIcon = getNavigationAndActionIcon('external_link')

export type ExternalLinkProps<Component extends ElementType = 'a'> = Omit<
  LinkBaseProps<Component>,
  | 'underline'
  | 'locale'
  | 'isNextRoute'
  | 'isInline'
  | 'hasDefaultFocusVisible'
  | 'isExternal'
  | 'target'
  | 'icon'
  | 'surface'
> & {
  component?: Component
  isInText?: boolean
} & ComponentPropsWithoutRef<Component>

const ExternalLink = <Component extends ElementType = 'a'>({
  children,
  component,
  isInText = false,
  hasNoSpacing,
  ...rest
}: ExternalLinkProps<Component>): ReactElement | null => (
  <LinkBase
    {...rest}
    component={component || 'a'}
    hasNoSpacing={isInText || hasNoSpacing}
    hasDefaultFocusVisible={isInText}
    underline={isInText ? 'always' : 'none'}
    icon={ExternalLinkIcon}
    isInline={isInText}
    isExternal
  >
    {children}
  </LinkBase>
)

export default ExternalLink
